import React from 'react';

import { Box } from '@mui/material';

import Typography from '@/components/Typography';

const Heading = ({ title, subtitle }: { title: string; subtitle: string }) => {
  return (
    <Box>
      <Typography
        size={24}
        sx={{ fontWeight: 'bold' }}
      >
        {title}
      </Typography>
      <Typography
        color='textDisabled'
        size={14}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Heading;
